import { DeepPartial } from '@empiriecom/module-components/utils/interfaces';
import deepmerge from '@/src/utils/deepmergeconfig';
import { tenantConfig } from '@empiriecom/mybuy-components/config/baurde';
import defaultConfig from './default';
import { FragmentConfig } from './types';

const baurdeconfig: DeepPartial<FragmentConfig> = {
  ...tenantConfig,
  l10n: {
    'de-DE': ['base-de', 'base-de-du', 'baurde-de'],
  },
  ccLogin: {
    ADFSEnabled: true,
    host: 'https://adfs.baur.de/adfs/oauth2',
    redirectURL: '/mein-konto/callcenter/adfstokenresponse',
    clientID: 'CallcenterLoginClient',
    resource: 'callcentershoplogin',
    devClientID: 'CallcenterLoginClient_Dev',
    devResource: 'callcentershoplogin_dev',
  },
  companyId: 'baurde',
  customerTypes: {
    employees: [80, 81, 82],
  },
  personalData: {
    supressEmailChange: true,
  },
  bookings: {
    overview: {
      hasExplicitMaturities: true,
      showOpenPayment: 'installments',
    },
  },
  lounge: {
    showStatusAndData: true,
    showHint: false,
    icon: (language: string) =>
      `https://bilder.baur.de/empiriecom/io/baurde/${language}/premiumicon.svg`,
    banner: (language: string, device: string) =>
      `https://bilder.baur.de/empiriecom/io/baurde/${language}/lounge_banner_${device}.jpg`,
    basicExternalLoungeContent:
      'https://fragment-content-external.baurde.empirie.cloud/mein-konto/mein-flat-more-lounge',
  },
  paylink: {
    ...tenantConfig.paylink,
    enabled: true,
  },
  tracking: {
    gtmId: 'GTM-W3MMXTW',
    soastaId: 'FP553-5JWM6-76MK6-QR4XN-3XLRP',
    tagmanagerSrc: 'https://s.baur.de/btm',
  },
  permissions: {
    eInvoiceEnabled: false,
  },
  einvoice: {
    isFixedFooter: true,
  },
  images: {
    logoSmall: {
      default: 'https://bilder.baur.de/i/empiriecom/baur_logo_small.png',
    },
  },
  returnDeclaration: {
    enabled: true,
  },
  blackFridayNoti: false,
  chatBot: {
    enabled: true,
    key: '418f4be1c3574c2daa41d05ac9603d32c52d03af187b49dc81805ff5eb0a2c33',
    visibility: {
      main: true,
      button: true,
      notifications: false,
    },
  },
};

export default deepmerge(defaultConfig, baurdeconfig) as FragmentConfig;
